import {
  getDisplayLanguageEntries,
  getNativeLanguageName,
  getResultLanguageEntries
} from "@/lib/constants/languages";
import { ComboboxOption } from "@/components/ui/combobox";

/**
 * Convert display language entries to ComboboxOption format for searchable selects
 */
export const getDisplayLanguageOptions = (): ComboboxOption[] => {
  return getDisplayLanguageEntries().map(([code, label]) => ({
    value: code,
    label: `${getNativeLanguageName(label)} (${label})`,
  }));
};

/**
 * Convert result language entries to ComboboxOption format for searchable selects
 */
export const getResultLanguageOptions = (): ComboboxOption[] => {
  return getResultLanguageEntries().map(([code, label]) => ({
    value: code,
    label: `${getNativeLanguageName(label)} (${label})`,
  }));
};

/**
 * Get result language options with "Same as display" option prepended
 */
export const getResultLanguageOptionsWithSame = (
  sameAsDisplayLabel: string = "Same as display language"
): ComboboxOption[] => {
  return [
    { value: "same", label: sameAsDisplayLabel },
    ...getResultLanguageOptions()
  ];
};
